import { expand } from 'uri-template-lite';
import { z } from 'zod/v3';
import { apiClient } from '../../common/ApiClient';
import { createApiQueryHook } from '../../common/queryClient/createApiQueryHook';
import { DataObjectUrl } from './DataObjectUrl';

const ReportVersionDataInfoSchema = z.object({
  columns: z
    .object({
      code: z.string(),
      name: z.string(),
      isDimension: z.boolean(),
      isIndicator: z.boolean(),
    })
    .transform(({ isDimension, isIndicator, ...data }) =>
      isDimension
        ? { ...data, isDimension }
        : isIndicator
          ? { ...data, isIndicator }
          : data,
    )
    .array(),
});

export type ReportVersionDataInfoType = z.output<
  typeof ReportVersionDataInfoSchema
>;

const getReportVersionDataInfo = (params: { dataObjectVersionId: number }) =>
  apiClient
    .get(expand(DataObjectUrl.REPORT_VERSION_DATA_INFO, params))
    .then((response) => ReportVersionDataInfoSchema.parse(response.data));

export const useReportVersionDataInfoQuery = createApiQueryHook(
  ['report-version-data-info'],
  getReportVersionDataInfo,
);
